import React from 'react';
import { AuthHelper } from '../..//libs/auth/AuthHelper';
import { AppState, useClasses } from '../../App';
import { BackendProbe, ChatView, Error, Loading } from '../views';
import { AgentSelectListItem } from '../../libs/services/AgentService';

const Chat = ({
    classes,
    appState,
    setAppState,
    agents,
}: {
    classes: ReturnType<typeof useClasses>;
    appState: AppState;
    setAppState: (state: AppState) => void;
    agents: AgentSelectListItem[];
}) => {
    const [selectedAgentId, setSelectedAgentId] = React.useState<string>('');
    const onBackendFound = React.useCallback(() => {
        setAppState(
            AuthHelper.isAuthAAD()
                ? // if AAD is enabled, we need to set the active account before loading chats
                  AppState.SettingUserInfo
                : // otherwise, we can load chats immediately
                  AppState.LoadChats,
        );
    }, [setAppState]);
    return (
        <div className={classes.container}>
            {appState === AppState.ProbeForBackend && <BackendProbe onBackendFound={onBackendFound} />}
            {appState === AppState.SettingUserInfo && <Loading text={'Bilgileriniz yükleniyor...'} />}
            {appState === AppState.ErrorLoadingUserInfo && (
                <Error text={'Kullanıcı bilgileri yüklenemedi. Lütfen çıkış yapıp tekrar giriş yapınız.'} />
            )}
            {appState === AppState.ErrorLoadingChats && (
                <Error text={'Sohbetler yüklenemedi. Lütfen sayfayı yenileyiniz.'} />
            )}
            {appState === AppState.LoadingChats && <Loading text="Sohbetler yükleniyor..." />}
            {appState === AppState.Chat && (
                <ChatView
                    selectedAgentId={selectedAgentId}
                    setSelectedAgentId={setSelectedAgentId}
                    agents={agents}
                    setLoadingState={() => {
                        setAppState(AppState.SigningOut);
                    }}
                />
            )}
        </div>
    );
};
export default Chat;
